import React from "react";
import { Reveal, RevealWords } from "../../lib/ui-motion";

export const SectionHeading = ({ overline, title, sub, align = "left", className = "" }) => (
  <div className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl ${className}`}>
    <Reveal>
      <div className={`flex items-center gap-3 mb-5 ${align === "center" ? "justify-center" : ""}`}>
        <span className="h-px w-8 bg-flame" />
        <span className="text-xs sm:text-sm font-mono uppercase tracking-[0.25em] text-flame font-medium">{overline}</span>
      </div>
    </Reveal>
    <h2 className="font-heading font-bold tracking-tight text-4xl md:text-5xl lg:text-6xl leading-[1.02] text-balance">
      <RevealWords text={title} />
    </h2>
    {sub && (
      <Reveal delay={0.15}>
        <p className={`mt-5 text-lg text-white/55 leading-relaxed ${align === "center" ? "mx-auto" : ""} max-w-2xl`}>{sub}</p>
      </Reveal>
    )}
  </div>
);
